import { Link } from "react-router-dom";
import { Box, Phone, Facebook, Mail } from "lucide-react";
import { CONTACT } from "@/lib/data";

export const Footer = () => (
  <footer className="bg-crate-black border-t border-white/10 pt-20 pb-10" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center h-10 w-10 rounded-xl bg-crate-yellow text-crate-black">
              <Box className="h-6 w-6" strokeWidth={2.5} />
            </span>
            <span className="font-heading font-extrabold text-xl text-white">Color Crate<span className="text-crate-yellow">.</span></span>
          </Link>
          <p className="text-white/60 max-w-sm leading-relaxed">
            Durable, reusable moving totes delivered to your door across Southwest Iowa. Move smarter. Pack by color.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="grid place-items-center h-11 w-11 rounded-full border border-white/15 text-white hover:bg-crate-yellow hover:text-crate-black hover:border-crate-yellow transition-colors" data-testid="footer-facebook">
              <Facebook className="h-5 w-5" />
            </a>
            <a href={CONTACT.phoneHref} className="grid place-items-center h-11 w-11 rounded-full border border-white/15 text-white hover:bg-crate-yellow hover:text-crate-black hover:border-crate-yellow transition-colors" data-testid="footer-phone">
              <Phone className="h-5 w-5" />
            </a>
            <a href={`mailto:${CONTACT.email}`} className="grid place-items-center h-11 w-11 rounded-full border border-white/15 text-white hover:bg-crate-yellow hover:text-crate-black hover:border-crate-yellow transition-colors" data-testid="footer-email">
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-widest">Quick Links</h4>
          <ul className="space-y-3 text-white/60">
            {[["Home","/"],["About Us","/about"],["Pricing","/pricing"],["Reserve","/reserve"],["FAQ","/faq"],["Contact","/contact"]].map(([l,to]) => (
              <li key={to}><Link to={to} className="hover:text-crate-yellow transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-widest">Get In Touch</h4>
          <ul className="space-y-3 text-white/60">
            <li><a href={CONTACT.phoneHref} className="hover:text-crate-yellow transition-colors">{CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="hover:text-crate-yellow transition-colors">{CONTACT.email}</a></li>
            <li className="pt-2 text-sm">Clarinda · Shenandoah · Red Oak · Essex · Sidney</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
        <p>© {new Date().getFullYear()} Color Crate Moving. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
        </div>
      </div>
    </div>
  </footer>
);
